/* eslint-disable react/no-children-prop */
import React, { FC } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

interface CartCounts {
  to?: string;
  title?: string;
  subtitle?: string | number;
  children?: any;
}

const CardCounts: FC<CartCounts> = props => {
  const { title, subtitle, to, children } = props;
  const navigate = useNavigate();
  return (
    <Flex
      p="15px"
      m="5px"
      w="250px"
      h="120px"
      align="center"
      boxShadow="0px 2px 4px #00000050"
      borderRadius="2px"
      background="theme.light.bodySecondary"
      transition="0.3s ease"
      cursor={to ? 'pointer' : 'default'}
      _hover={to ? { opacity: 0.6, color: 'white' } : {}}
      onClick={() => (to ? navigate(to) : {})}
    >
      <Flex align="center" justify="start">
        <Box textAlign="left">
          <Text fontWeight="300" fontSize="20px">
            {title}
          </Text>
          <Text color="#34353E" fontWeight="700" fontSize={35}>
            {subtitle}
          </Text>
        </Box>
      </Flex>
      {children}
    </Flex>
  );
};

export default CardCounts;
